<template></template>
<script>
import { ref } from "vue";
import Map from "@/utils/Map.js";
import Timer from "@/utils/Timer";
import { toast } from "vue3-toastify";

export default {
  name: "DroneMap",
  components: {},
  props: {
    config: Object,
  },
  setup() {
    return {
      drone: ref(false),
      measureTarget: ref(false),
      heading: ref(0),
      pitch: ref(-26.75),
      handler: ref(false),
      color: ref("#ffff00"),
      colorSelected: ref("#62b3ff"),
      listPrimitiveDrone: ref([]),
      frustum: ref(null),
      datasource: ref(null),
      id: ref(null),
    };
  },

  mounted() {
    this.config.drone.hideFrustrum = true;
    this.frustum = {
      near: 5,
      far: 100,
      fov: 80,
      heading: 0,
      pitch: -45,
      zoom: 4,
      prim: undefined,
      primout: undefined,
      isAction: false,
    };


    /** PLACEMENT */
    this.placementDataSource();
    this.placementDrone();
    this.placementMeasureTarget();

    /** UPDATE */
    // Timer.addRequest(`FrustumTimer_${this.config.drone.id}`, {
    //   timer: async () => {
    //     this.FrustumTimer()
    //   },
    // });

    this.id = setInterval(() => {
      this.FrustumTimer();
    }, 100);
  },

  unmounted() {
    if (this.$root.isPopup) return;

    // Timer.closeRequest(`FrustumTimer_${this.config.drone.id}`);
    clearInterval(this.id);
    this.clear();
    Map.getViewer().entities.remove(this.drone);
    Map.getViewer().dataSources.remove(this.datasource);
    this?.handler?.destroy();
  },

  methods: {
    placementDataSource() {
      if(Map.getViewer()?.dataSources == undefined) {
        setTimeout(() => {
          this.placementDataSource();
        }, 2000);
        return;
      }

      const datasourceName = "DroneElements_" + this.config.drone.id;
      this.datasource = new Cesium.CustomDataSource(datasourceName);
      Map.getViewer().dataSources.add(this.datasource);
    },

    placementDrone() {
      if (this.datasource?.entities == undefined) {
        setTimeout(() => {
          this.placementDrone();
        }, 2000);
        return;
      }

      this.config.drone.focus = false;

      let url =
        process.env.NODE_ENV === "development"
          ? "/public/assets/3dModel/FlecheFlyinEye.glb"
          : window.location.origin + "/assets/3dModel/FlecheFlyinEye.glb";

      url = window.location.origin + "/assets/3dModel/FlecheFlyinEye.glb";

      //this.drone = Map.getViewer().entities.add({
      const entityDrone = {
        // id: 'Drone',
        name: `#${this.config.drone.id} - ${this.config.drone.name}`,

        position: new Cesium.CallbackProperty(() => {
          return this.updateDrone().position;
        }, false),
        orientation: new Cesium.CallbackProperty(() => {
          return this.updateDrone().orientation;
        }, false),
        show: new Cesium.CallbackProperty(() => {
          return this.updateDrone().show;
        }, false),

        model: {
          uri: url,
          scale: 10, //0.003,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            Map.get_max_distance_show()
          ),
          zIndex: 999,
          colorBlendMode: Cesium.ColorBlendMode.REPLACE,
          colorBlendAmount: 1,
          color: Cesium.Color.fromCssColorString(this.color),
          shadows: Cesium.ShadowMode.DISABLED,
        },

        label: {
          text: `#${this.config.drone.id} - ${this.config.drone.name}`,
          font: "600 14px Inter, sans-serif",
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          showBackground: true,
          backgroundColor: Cesium.Color.BLACK,
          outlineWidth: 5,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          eyeOffset: new Cesium.Cartesian3(0, 5, 0),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            5000
          ),
        },
      };

      this.drone = this.datasource.entities.add(entityDrone);
      this.config.drone.entityId = this.drone.id;

      this.handler = new Cesium.ScreenSpaceEventHandler(
        Map.getViewer().scene.canvas
      );

      this.handler.setInputAction((movement) => {
        this.FocusDrone(movement);
      }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    },

    placementMeasureTarget() {
      if (this.datasource?.entities == undefined) {
        setTimeout(() => {
          this.placementMeasureTarget();
        }, 2000);
        return;
      }

      let svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.52 169.9"><g id="a"><g id="b"><path id="c" d="M49.76,143.45l35.44-60.34L49.76,30.31,11.39,83.11l38.37,60.34Z" style="fill:#315da8; opacity:.6;"/><path id="d" d="M43.54,10.63L0,84.95l16.33,27.87,33.43,57.07,21.39-36.51,28.38-48.44-6.22-10.62L55.98,10.62,49.76,0l-6.22,10.63ZM74.64,84.95l-24.88,42.47-24.88-42.47,24.88-42.47,24.88,42.47Z" style="fill:#315da8;"/></g></g><g id="e"><path d="M44.36,93.9c-4.94,0-8.95-4.02-8.95-8.95s4.02-8.95,8.95-8.95c3.26,0,6.21,1.75,7.78,4.54h27.59c1.67,0,3.03,1.36,3.03,3.03v2.76c0,1.67-1.36,3.03-3.03,3.03h-27.59c-1.57,2.79-4.52,4.54-7.78,4.54Z" style="fill:#315da8;"/><path d="M44.36,77.67c3.05,0,5.66,1.88,6.74,4.54h28.63c.75,0,1.36.61,1.36,1.36v2.76c0,.75-.61,1.36-1.36,1.36h-28.63c-1.08,2.66-3.69,4.54-6.74,4.54-4.02,0-7.28-3.26-7.28-7.28s3.26-7.28,7.28-7.28M44.36,74.33c-5.86,0-10.62,4.76-10.62,10.62s4.76,10.62,10.62,10.62c3.53,0,6.75-1.73,8.7-4.54h26.67c2.59,0,4.7-2.11,4.7-4.7v-2.76c0-2.59-2.11-4.7-4.7-4.7h-26.67c-1.96-2.82-5.17-4.54-8.7-4.54h0Z" style="fill:#fff;"/><path d="M42.98,117.75c-1.67,0-3.02-1.36-3.02-3.02v-12.9c-1.55-.4-3.03-1.01-4.41-1.82l-5.18,5.18c-.57.57-1.33.89-2.14.89s-1.57-.31-2.14-.89l-1.96-1.96c-1.18-1.18-1.18-3.1,0-4.28l5.18-5.18c-.81-1.38-1.42-2.85-1.82-4.41h-7.71c-1.67,0-3.02-1.36-3.02-3.02v-2.77c0-1.67,1.36-3.02,3.02-3.02h7.71c.4-1.55,1.01-3.03,1.82-4.41l-5.18-5.18c-.57-.57-.89-1.33-.89-2.14s.31-1.57.89-2.14l1.96-1.96c.57-.57,1.33-.89,2.14-.89s1.57.31,2.14.89l5.18,5.18c1.38-.81,2.85-1.42,4.41-1.82v-12.9c0-1.67,1.36-3.02,3.02-3.02h2.77c1.67,0,3.02,1.36,3.02,3.02v21.46l-2.09-.54c-.79-.21-1.57-.31-2.32-.31-.36,0-.73.03-1.13.08l-.14.02c-.36.05-.72.12-1.04.21-1.12.29-2.15.78-3.08,1.46l-2.01,2.01c-1.16,1.58-1.77,3.44-1.77,5.39s.61,3.81,1.77,5.4l2.01,2.01c.93.68,1.96,1.17,3.08,1.46.33.09.68.16,1.07.21l.12.02c.41.05.78.08,1.13.08.75,0,1.53-.1,2.32-.31l2.09-.55v21.46c0,1.67-1.36,3.02-3.02,3.02h-2.77Z" style="fill:#315da8;"/><path d="M45.75,53.81c.75,0,1.36.61,1.36,1.36v19.3c-.88-.23-1.79-.36-2.74-.36-.46,0-.91.03-1.35.09-.05,0-.09.02-.14.02-.42.06-.84.14-1.25.25-1.41.37-2.7,1.01-3.82,1.86-.02.02-.02.04-.04.05l-1.96,1.96s-.04.02-.05.04c-1.39,1.82-2.23,4.09-2.23,6.56s.84,4.74,2.23,6.56c.02.01.04.02.05.04l1.96,1.96s.02.04.04.05c1.12.86,2.41,1.5,3.82,1.86.41.11.83.19,1.25.25.05,0,.1.02.14.02.44.06.89.09,1.35.09.95,0,1.86-.13,2.74-.36v19.3c0,.75-.61,1.36-1.36,1.36h-2.77c-.75,0-1.36-.61-1.36-1.36v-14.25c-2.32-.41-4.46-1.31-6.31-2.61l-6.13,6.13c-.26.26-.61.4-.96.4s-.69-.13-.96-.4l-1.96-1.96c-.53-.53-.53-1.39,0-1.92l6.13-6.13c-1.3-1.85-2.2-3.99-2.61-6.31h-9.05c-.75,0-1.35-.61-1.35-1.36v-2.77c0-.75.61-1.36,1.35-1.36h9.05c.41-2.31,1.31-4.46,2.61-6.31l-6.13-6.13c-.53-.53-.53-1.39,0-1.92l1.96-1.96c.26-.26.61-.4.96-.4s.69.13.96.4l6.13,6.13c1.85-1.3,3.99-2.2,6.31-2.61v-14.25c0-.75.61-1.36,1.36-1.36h2.77M45.75,50.48h-2.77c-2.59,0-4.69,2.1-4.69,4.69v11.66c-.84.28-1.65.62-2.44,1.01l-4.3-4.3c-.89-.89-2.06-1.37-3.32-1.37s-2.43.49-3.32,1.37l-1.96,1.96c-1.83,1.83-1.83,4.81,0,6.63l4.3,4.3c-.39.79-.73,1.6-1.01,2.44h-6.46c-2.59,0-4.69,2.1-4.69,4.69v2.77c0,2.59,2.1,4.69,4.69,4.69h6.46c.28.84.62,1.65,1.01,2.44l-4.3,4.3c-1.83,1.83-1.83,4.81,0,6.63l1.96,1.96c.89.89,2.06,1.37,3.32,1.37s2.43-.49,3.32-1.37l4.3-4.3c.79.39,1.6.73,2.44,1.01v11.66c0,2.59,2.1,4.69,4.69,4.69h2.77c2.59,0,4.69-2.1,4.69-4.69v-23.62l-4.18,1.09c-.65.17-1.29.26-1.9.26-.28,0-.58-.02-.9-.06l-.14-.02c-.3-.04-.59-.1-.86-.17-.87-.23-1.68-.6-2.42-1.12l-1.81-1.82c-.9-1.27-1.38-2.76-1.38-4.31s.48-3.04,1.38-4.31l1.82-1.82c.73-.52,1.54-.89,2.42-1.12.27-.07.56-.13.89-.18l.12-.02c.33-.04.62-.06.89-.06.61,0,1.25.09,1.9.26l4.18,1.09v-23.62c0-2.59-2.1-4.69-4.69-4.69h0Z" style="fill:#fff;"/><path d="M53.88,80.42c-.81,0-1.57-.31-2.14-.89l-1.96-1.96c-1.18-1.18-1.18-3.1,0-4.28l8.58-8.57c.57-.57,1.33-.89,2.14-.89s1.57.31,2.14.89l1.96,1.96c1.18,1.18,1.18,3.1,0,4.28l-8.57,8.57c-.57.57-1.33.89-2.14.89Z" style="fill:#315da8;"/><path d="M60.5,65.5c.35,0,.69.13.96.4l1.96,1.96c.53.53.53,1.39,0,1.92l-8.57,8.57c-.26.26-.61.4-.96.4s-.69-.13-.96-.4l-1.96-1.96c-.53-.53-.53-1.39,0-1.92l8.57-8.58c.26-.26.61-.4.96-.4M60.5,62.17c-1.25,0-2.43.49-3.32,1.37l-8.58,8.58c-.89.89-1.37,2.06-1.37,3.32s.49,2.43,1.37,3.32l1.96,1.96c.89.89,2.06,1.37,3.32,1.37s2.43-.49,3.32-1.37l8.57-8.57c1.83-1.83,1.83-4.81,0-6.63l-1.96-1.96c-.89-.89-2.07-1.37-3.32-1.37h0Z" style="fill:#fff;"/><path d="M60.5,106.06c-.81,0-1.57-.31-2.14-.89l-8.58-8.57c-.57-.57-.89-1.33-.89-2.14s.32-1.57.89-2.14l1.96-1.96c.57-.57,1.33-.89,2.14-.89s1.57.31,2.14.89l8.57,8.57c1.18,1.18,1.18,3.1,0,4.28l-1.96,1.96c-.57.57-1.33.89-2.14.89Z" style="fill:#315da8;"/><path d="M53.88,91.15c.35,0,.69.13.96.4l8.57,8.57c.53.53.53,1.39,0,1.92l-1.96,1.96c-.26.26-.61.4-.96.4s-.69-.13-.96-.4l-8.57-8.57c-.53-.53-.53-1.39,0-1.92l1.96-1.96c.27-.26.61-.4.96-.4M53.88,87.81c-1.25,0-2.43.49-3.32,1.37l-1.96,1.96c-.89.89-1.37,2.06-1.37,3.32s.49,2.43,1.37,3.32l8.57,8.57c.89.89,2.06,1.37,3.32,1.37s2.43-.49,3.32-1.37l1.96-1.96c1.83-1.83,1.83-4.81,0-6.63l-8.58-8.58c-.89-.89-2.06-1.37-3.32-1.37h0Z" style="fill:#fff;"/></g></svg>
      `;

      var entityMeasureTarget = {
        name: `#${this.config.drone.id} - ` + this.$e(`Télémètre`),

        position: new Cesium.CallbackProperty(() => {
          return this.updateMeasureTarget().position;
        }, false),
        show: new Cesium.CallbackProperty(() => {
          return this.updateMeasureTarget().show;
        }, false),

        billboard: {
          image: `data:image/svg+xml;base64,` + btoa(svg),
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          scaleByDistance: new Cesium.NearFarScalar(1.5e2, 0.8, 1.5e7, 0.5),
          pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
            1.0e3,
            0.8,
            1.5e6,
            0.0
          ),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          // heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
          clampToGround: true,
          scale: 0.5,
        },

        label: {
          text: `#${this.config.drone.id} - ` + this.$e(`Télémètre`),
          font: "600 14px Inter, sans-serif",
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          showBackground: true,
          backgroundColor: Cesium.Color.BLACK,
          outlineWidth: 5,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          eyeOffset: new Cesium.Cartesian3(0, 8, 0),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            5000
          ),
        },
      }

      this.measureTarget = this.datasource.entities.add(entityMeasureTarget);
      this.config.drone.measureTargetEntityId = this.measureTarget.id;
    },

    FocusDrone(movement) {
      if (
        ["Site_FlightCurrent_device", "Site_FlightCurrent"].includes(
          this.$route.name
        )
      ) {
        return;
      }
      let pickedObject = Map.getViewer().scene.pick(movement.position);
      let idDrone = btoa(this?.config?.drone?.entityId);
      let idPicked = btoa(pickedObject?.id?._id);
      let undefinedBTOA = btoa(undefined);

      if (idPicked !== undefinedBTOA && idPicked === idDrone) {
        this.config.drone.focus = true;
        this.config.infoType = "full";
      }
    },

    FrustumTimer() {
      this.hideFrustrum();
      // return;

      if (
        this.DroneLastPingAreOnline &&
        this.config?.drone?.hideFrustrum      != true &&
        this.config?.drone?.status?.longitude != undefined &&
        this.config?.drone?.status?.longitude != 0 &&
        this.config?.drone?.status?.latitude  != undefined &&
        this.config?.drone?.status?.latitude  != 0 &&
        this.config?.drone?.status?.height    != undefined &&
        // ---
        this.config?.camera?.status?.payload_status?.gimbal_pitch != undefined &&
        this.config?.camera?.status?.payload_status?.gimbal_yaw   != undefined &&
        this.config?.camera?.status?.payload_status?.zoom_factor  != undefined
      ) {
        var gimbal_pitch =
          this.config.camera.status.payload_status.gimbal_pitch;
        var gimbal_yaw = this.config.camera.status.payload_status.gimbal_yaw;
        var zoom_factor = 1;

        if (this.config?.camera?.status?.video_type == "ir") {
          zoom_factor = Math.min(
            Math.max(1 / this.config.camera.status.zoom_factor, 1),
            50
          );
        } else if (this.config?.camera?.status?.video_type == "zoom") {
          zoom_factor = Math.min(
            Math.max(this.config.camera.status.zoom_factor, 1),
            50
          );
        }

        let cartographic = new Cesium.Cartographic(
          this.config.drone.status.longitude,
          this.config.drone.status.latitude,
          this.config.drone.status.height
        );

        if (
          this.frustum.prim === undefined ||
          this.frustum.zoom !== zoom_factor
        ) {
          this.frustum.zoom = zoom_factor;
          this.addFrustum();
        }

        if (this.$root.debug) {
          this.frustum.heading = gimbal_yaw + this.config.drone.status.attitude_head;
        } else {
          this.frustum.heading = gimbal_yaw;
        }
        this.frustum.pitch = gimbal_pitch;
        this.updateFrustum(cartographic);

        // if (this.config?.drone?.focus == true) {
        //   this.drone.model.color = Cesium.Color.fromCssColorString(this.colorSelected);
        // }
        // else {
        //   this.drone.model.color = Cesium.Color.fromCssColorString(this.color);
        // }
      } else {
        this.hideFrustrum();
      }
    },

    updateDrone() {
      let r = {
        position: Cesium.Cartesian3.fromDegrees(0, 0, 0),
        orientation: Cesium.Transforms.headingPitchRollQuaternion(
          Cesium.Cartesian3.fromDegrees(0, 0, 0),
          new Cesium.HeadingPitchRoll(0, 0, 0)
        ),
        show: false,
      };

      if (
        this.config?.drone?.status?.longitude != undefined &&
        this.config?.drone?.status?.longitude != 0 &&
        this.config?.drone?.status?.latitude != undefined &&
        this.config?.drone?.status?.latitude != 0 &&
        this.config?.drone?.status?.height != undefined
      ) {
        let position = Cesium.Cartesian3.fromDegrees(
          this.config.drone.status.longitude,
          this.config.drone.status.latitude,
          this.config.drone.status.height
        );

        r.position = position;
        r.show = true;

        if (
          this.config?.drone?.status?.attitude_head != undefined &&
          this.config?.drone?.status?.attitude_pitch != undefined &&
          this.config?.drone?.status?.attitude_roll != undefined
        ) {
          let attitude_head = this.config.drone.status.attitude_head;
          let attitude_pitch = this.config.drone.status.attitude_pitch;
          let attitude_roll = this.config.drone.status.attitude_roll;

          attitude_head = Cesium.Math.toRadians(attitude_head);
          attitude_pitch = Cesium.Math.toRadians(attitude_pitch);
          attitude_roll = Cesium.Math.toRadians(attitude_roll);

          let hpr = new Cesium.HeadingPitchRoll(
            attitude_head,
            attitude_roll,
            attitude_pitch
          );
          r.orientation = Cesium.Transforms.headingPitchRollQuaternion(
            position,
            hpr
          );
          // headingPitchRollToFixedFrame
        }
      } else {
        r.show = false;
      }
      return r;
    },

    updateMeasureTarget() {
      let r = {
        position: Cesium.Cartesian3.fromDegrees(0, 0, 0),
        orientation: Cesium.Transforms.headingPitchRollQuaternion(
          Cesium.Cartesian3.fromDegrees(0, 0, 0),
          new Cesium.HeadingPitchRoll(0, 0, 0)
        ),
        show: false,
      };

      if(
        this.config?.openTelemetreLaser == false ||
        this.config?.openTelemetreLaser == undefined ||
        this.config?.camera?.payload_index == false ||
        this.config?.camera?.payload_index == undefined
      ) {
        return r;
      }

      if(
        this.config?.drone?.status[this.config?.camera?.payload_index]?.measure_target_longitude != undefined &&
        this.config?.drone?.status[this.config?.camera?.payload_index]?.measure_target_longitude != 0 &&
        this.config?.drone?.status[this.config?.camera?.payload_index]?.measure_target_latitude != undefined &&
        this.config?.drone?.status[this.config?.camera?.payload_index]?.measure_target_latitude != 0 &&
        this.config?.drone?.status[this.config?.camera?.payload_index]?.measure_target_altitude != undefined
      ) {
        let position = Cesium.Cartesian3.fromDegrees(
          this.config.drone.status[this.config.camera.payload_index].measure_target_longitude,
          this.config.drone.status[this.config.camera.payload_index].measure_target_latitude,
          this.config.drone.status[this.config.camera.payload_index].measure_target_altitude
        );

        r.position = position;
        r.show = true;
      }

      return r;
    },

    ShowTheDrone() {
      if (this.drone !== false && this.drone?.show) {
        Map.getViewer().camera.lookAt(
          this.drone.position.getValue(Date.now()),
          new Cesium.Cartesian3(0, 0, 100)
        );
        Map.getViewer().camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      } else {
        toast.error("Position du drone inconnu", this.$root.toastConfig);
      }
    },

    addFrustum() {
      if (this.frustum.prim !== undefined) {
        this.datasource._primitives.remove(this.frustum.prim);
        this.frustum.prim = undefined;
      }
      if (this.frustum.primout !== undefined) {
        this.datasource._primitives.remove(this.frustum.primout);
        this.frustum.primout = undefined;
      }

      let frustum = new Cesium.PerspectiveFrustum();
      frustum.fov = Cesium.Math.toRadians(this.frustum.fov / this.frustum.zoom);
      frustum.aspectRatio =
        Map.getViewer().canvas.height / Map.getViewer().canvas.width;
      frustum.near = this.frustum.near;
      frustum.far = this.frustum.far;

      let colorprim = new Cesium.Color(1.0, 1.0, 1.0, 0.15);
      let colorprimout = new Cesium.Color(0.0, 1.0, 0.0, 0.2);

      let prim = new Cesium.Primitive({
        geometryInstances: new Cesium.GeometryInstance({
          geometry: new Cesium.FrustumGeometry({
            origin: new Cesium.Cartesian3(0, 0, 0),
            orientation: Cesium.Quaternion.fromHeadingPitchRoll(
              new Cesium.HeadingPitchRoll(0, 0, 0),
              new Cesium.Quaternion()
            ),
            frustum: frustum,
            _drawNearPlane: true,
          }),
          attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(colorprim),
          },
          id: "frustum",
          pickPrimitive: this,
        }),
        appearance: new Cesium.PerInstanceColorAppearance({
          translucent: true,
          flat: true,
        }),
        asynchronous: false,
      });

      this.frustum.prim = this.datasource._primitives.add(prim);
      this.listPrimitiveDrone.push(this.frustum.prim);
      let primout = new Cesium.Primitive({
        geometryInstances: new Cesium.GeometryInstance({
          geometry: new Cesium.FrustumOutlineGeometry({
            origin: new Cesium.Cartesian3(0, 0, 0),
            orientation: Cesium.Quaternion.fromHeadingPitchRoll(
              new Cesium.HeadingPitchRoll(0, 0, 0),
              new Cesium.Quaternion()
            ),
            frustum: frustum,
            _drawNearPlane: true,
          }),
          attributes: {
            color:
              Cesium.ColorGeometryInstanceAttribute.fromColor(colorprimout),
          },
          id: "frustumline",
          pickPrimitive: this,
        }),
        appearance: new Cesium.PerInstanceColorAppearance({
          translucent: false,
          flat: true,
        }),
        asynchronous: false,
      });

      this.frustum.primout = this.datasource._primitives.add(primout);
      this.listPrimitiveDrone.push(this.frustum.primout);
    },

    hideFrustrum() {
      if (this.frustum?.prim?.modelMatrix == undefined) return;
      this.frustum.prim.modelMatrix = Cesium.Matrix4.IDENTITY;
      this.frustum.primout.modelMatrix = Cesium.Matrix4.IDENTITY;
    },

    updateFrustum(cartographic) {
      const cartesian = this.cartesian3FromCartographicDegrees(cartographic);
      const hpr = new Cesium.HeadingPitchRoll(
        Cesium.Math.toRadians(this.frustum.heading),
        Cesium.Math.toRadians(this.frustum.pitch - 90),
        0
      );

      const fixedFrameTransform =
        Cesium.Transforms.localFrameToFixedFrameGenerator("north", "west");
      const matrix = Cesium.Transforms.headingPitchRollToFixedFrame(
        cartesian,
        hpr,
        Cesium.Ellipsoid.WGS84,
        fixedFrameTransform
      );
      if (
        this.frustum.prim !== undefined &&
        this.frustum.primout !== undefined
      ) {
        this.frustum.prim.modelMatrix = matrix;
        this.frustum.primout.modelMatrix = matrix;
      }
    },

    clear() {
      this.datasource.entities.removeAll();
      this.listPrimitiveDrone.forEach((primitive) => {
        this.datasource._primitives.remove(primitive);
      });
      this.listPrimitiveDrone = [];
    },

    cartesian3FromCartographicDegrees(cartographic) {
      const cartesian = Cesium.Cartesian3.fromDegrees(
        cartographic.longitude,
        cartographic.latitude,
        cartographic.height
      );
      return cartesian;
    },
  },

  computed: {
    DroneLastPingAreOnline() {
      let LastPing =
        this.config?.drone?.status?.LastPing != undefined
          ? parseInt(this.config.drone.status.LastPing)
          : 999999;

      return LastPing < ENV.DEVICE_OFFLINE;
    },
  },

  watch: {
    config: {
      handler: function (val, oldVal) {
        if (this.config.drone.methods !== undefined) {
          this.config.drone.methods.ShowTheDrone = this.ShowTheDrone;
        }
      },
      deep: true,
    },
    "config.drone.status.is_near_area_limit": {
      handler: function (val, oldVal) {
        if (val == 1 && oldVal != 1) {
          let toastConfig = {
            ...this.$root.toastConfig
          }

          toastConfig.toastId = "toastDroneAreaLimit";


          toast.warning(
            this.$e("Votre drone est en limitte de zone de vol"),
            toastConfig
          );
        }
      },
      deep: true,
    },
    "config.drone.status.is_near_height_limit": {
      handler: function (val, oldVal) {
        if (val == 1 && oldVal != 1) {
          let toastConfig = {
            ...this.$root.toastConfig
          }

          toastConfig.toastId = "toastDroneHeightLimit";

          toast.warning(
            this.$e("Votre drone est en limitte hauteur de vol"),
            toastConfig
          );
        }
      },
      deep: true,
    },
    "config.drone.status.distance_limit_status.is_near_distance_limit": {
      handler: function (val, oldVal) {
        if (
          val == 1 &&
          oldVal != 1 &&
          this.config?.drone?.status?.distance_limit_status?.state == 1
        ) {
          let toastConfig = {
            ...this.$root.toastConfig
          }

          toastConfig.toastId = "toastDroneDistanceLimit";

          toast.warning(
            this.$e("Votre drone est en limitte de distance autoriser à partir de son Home"),
            toastConfig
          );
        }
      },
      deep: true,
    },
  },
};
</script>
